import { post } from '@api/request';

export async function fetchEvents(
  { eventService },
  authenticationToken,
  { taxingUnitID },
) {
  const url = `${eventService}/events/search`;
  const { body } = await post(authenticationToken, url, {
    objectID: `${taxingUnitID}`,
    dataObject: 'taxing unit',
  });
  return body;
}
